import { DNRDModel } from "@10x/tabu-mobile-api";
import { ServerDate } from "@eres/core";
import { RegisterTabuLookup } from "@my-dld/tabuapi";
import { ReqTabuDoc } from "../TabuRequest/BaseTabuRequestForm";
import moment from "moment";

export type DNRDModelX = DNRDModel & {
	PassportIssueDate?: ServerDate, PassportIssuePlace?: string;
	Gender?: RegisterTabuLookup;

	NationalDocuments?: ReqTabuDoc[];
	ResidenceDocuments?: ReqTabuDoc[];
};

export function checkExceedLimit( compareDate: Date ) {
	const dateLimit = moment( compareDate, "YYYY-MM-DDThh:mm:ss" );
	const now = moment();
	if ( dateLimit.isValid() && dateLimit.isAfter( now ) ) {
		return true;
	}
	return false;
}
